import config from '../../config';
import router from '../../router'

export default class ExtensionBridge {

    static _postMessage(payload) {

        const isPopup = window.top !== window;

        const isDesktopApp = router.app.$route.query.origin === 'desktopapp';

        if(isDesktopApp){
            window.ElectronAPI.postMessage(payload)
        }else if (isPopup) {
            window.top.postMessage(payload, '*');
        } else {

            chrome.runtime.sendMessage(config.chromeExtensionId, payload);

        }

    }

    static _listenForMessage(fn){

        const isDesktopApp = router.app.$route.query.origin === 'desktopapp';

        if(isDesktopApp){

            window.ElectronAPI.listenPostMessage(fn);

        }else{

            window.addEventListener('message', fn);

        }

    }

    static resize(height) {
        this._postMessage({type: 'resizeWindow', payload: {height}});
    }

    static syncUserState(userState) {

        this._postMessage({type: 'syncUserState', payload: userState});

    }

    static clearUserState() {

        this._postMessage({type: 'clearUserState'});

    }

    static subscriptionCreated() {

        this._postMessage({type: 'subscriptionCreated'});

    }

    static register(eventListeners) {

        this._listenForMessage((event) => {

            if (eventListeners[event.data.type]) {
                eventListeners[event.data.type](event.data.payload);
            }

        });

    }

    static connect(selectedServer) {

        this._postMessage({type: 'connect', selectedServer});

      return this.waitForConnectivity();

    }


    static openExtensionsTab(selectedServer) {

        this._postMessage({type: 'openExtensionsTab', selectedServer});


    }

    static waitForConnectivity(){

        return new Promise(resolve => {

            this._listenForMessage( (event) => {

                if (event.data.type === 'activeChange') {

                    resolve({
                        serverLocation: event.data.serverLocation,
                        connected: event.data.active,
                        notControllable: false
                    });

                } else if (event.data.type === 'extensionNotControllable') {

                    resolve({
                        serverLocation: event.data.serverLocation,
                        connected: event.data.active,
                        notControllable: true
                    });
                }
            });

        });

    }

    static disconnect() {

        this._postMessage({type: 'disconnect'});

        return Promise.resolve({connected: false});

    }

}
